module.exports = __webpack_public_path__ + "img/Frame-0.2d99c44b.svg";